export const YELLOW_TEAM_NAME = 'Yellow';
